import { request2 } from '@/utils/httpClient'
import { getAuthHeaders } from './requestHelpers'

// 管理员登录
export const adminLoginAPI = (loginId, password) => {
  return request2({
    url: '/login/adminlogin',
    method: 'POST',
    data: {
      loginId,
      password
    },
    headers: getAuthHeaders()
  })
}

// 管理员上传渲染等待视频

export const adminUploadRenderLoadingVideo = (formData) => {
  return request2({
    url: '/back/video/upload',
    method: 'POST',
    data: formData,
    headers: getAuthHeaders({ 'Content-Type': 'multipart/form-data' })
  })
}

// 管理员获取渲染等待视频 URL

export const adminGetRenderLoadingVideoUrl = () => {
  return request2({
    url: '/back/video/url',
    method: 'GET',
    headers: getAuthHeaders()
  })
}

// AI Real CG 管理：设计素材库分页列表
export const fetchAdminDesignAssets = (params) => {
  return request2({
    url: '/back/design-assets/list',
    method: 'GET',
    headers: getAuthHeaders(),
    params,
  })
}

export const fetchAdminDesignAssetDetail = (idempotencyKey) => {
  return request2({
    url: `/back/design-assets/${encodeURIComponent(String(idempotencyKey || '').trim())}`,
    method: 'GET',
    headers: getAuthHeaders(),
  })
}

export const createAdminDesignAsset = (formData) => {
  return request2({
    url: '/back/design-assets/add',
    method: 'POST',
    data: formData,
    headers: getAuthHeaders({ 'Content-Type': 'multipart/form-data' }),
  })
}

// 編集：全項目の上書き。ファイルは差し替えるものだけ送る（送らないものは元の OSS を残す）
export const updateAdminDesignAsset = (idempotencyKey, formData) => {
  return request2({
    url: `/back/design-assets/${encodeURIComponent(String(idempotencyKey || '').trim())}/update`,
    method: 'POST',
    data: formData,
    headers: getAuthHeaders({ 'Content-Type': 'multipart/form-data' }),
  })
}

// 論理削除（status=DELETED、OSS のファイルは残る）
export const deleteAdminDesignAsset = (idempotencyKey) => {
  return request2({
    url: `/back/design-assets/${encodeURIComponent(String(idempotencyKey || '').trim())}`,
    method: 'DELETE',
    headers: getAuthHeaders(),
  })
}

// 管理员删除渲染等待视频

export const adminDeleteRenderLoadingVideo = () => {
  return request2({
    url: '/back/video/delete',
    method: 'DELETE',
    headers: getAuthHeaders()
  })
}

// 后台管理页面相关接口

  // 模块使用次数趋势
  export const moduleUsage = (startTime, endTime, type) => {
    return request2({
      url: '/back/user/dataListByTimeSlot?startTime='+startTime+'&endTime='+endTime+'&type='+type,
      method: 'GET',
      headers: {
        "token": localStorage.getItem('adminToken') || localStorage.getItem('token'),
        "username": localStorage.getItem('username'),
      }
    })
  }

  // 建筑图像渲染项目数据统计
  export const getRenderProjectStats = (startTime, endTime, type = 'day') => {
    const params = new URLSearchParams({
      startTime,
      endTime,
    });
    if (type) {
      params.append('type', type);
    }
    return request2({
      url: `/back/make-house/dataListByTimeSlot?${params.toString()}`,
      method: 'GET',
      headers: {
        "token": localStorage.getItem('adminToken') || localStorage.getItem('token'),
        "username": localStorage.getItem('username'),
      }
    })
  }

  // 建筑图像渲染项目列表
  export const getRenderProjectList = (pageNum, pageSize, content = '') => {
    const keyword = content ? encodeURIComponent(content) : '';
    return request2({
      url: `/back/make-house/list?pageNum=${pageNum}&pageSize=${pageSize}&content=${keyword}`,
      method: 'GET',
      headers: {
        "token": localStorage.getItem('adminToken') || localStorage.getItem('token'),
        "username": localStorage.getItem('username'),
      }
    })
  }

  // 活动代码列表（管理员）
  export const getCampaignCodeList = () => {
    return request2({
      url: '/back/campaign-code/list',
      method: 'GET',
      headers: {
        "token": localStorage.getItem('adminToken') || localStorage.getItem('token'),
        "username": localStorage.getItem('username'),
      }
    })
  }

  // 新增活动代码（管理员）
  export const addCampaignCode = (data) => {
    return request2({
      url: '/back/campaign-code/add',
      method: 'POST',
      data,
      headers: {
        "token": localStorage.getItem('adminToken') || localStorage.getItem('token'),
        "username": localStorage.getItem('username'),
        "Content-Type": "application/json"
      }
    })
  }

  // 删除活动代码（管理员）
  export const deleteCampaignCode = (id) => {
    return request2({
      url: `/back/campaign-code/${id}`,
      method: 'DELETE',
      headers: {
        "token": localStorage.getItem('adminToken') || localStorage.getItem('token'),
        "username": localStorage.getItem('username'),
      }
    })
  }

  // 用户反馈列表（管理员）
  export const getUserFeedbackList = (pageNum, pageSize, content = '') => {
    const keyword = content ? encodeURIComponent(content) : '';
    return request2({
      url: `/back/user-feedback/list?pageNum=${pageNum}&pageSize=${pageSize}&content=${keyword}`,
      method: 'GET',
      headers: {
        "token": localStorage.getItem('adminToken') || localStorage.getItem('token'),
        "username": localStorage.getItem('username'),
      }
    })
  }

  // 用户列表
    export const getUserList = (pageNum, pageSize, content, walletStatuses = '', subscriptionStatuses = '', sortBy = '', sortOrder = '', userTypes = '') => {
        let url = `/back/user/listUserProject?pageNum=${pageNum}&pageSize=${pageSize}&content=${content || ''}`;
        if (walletStatuses) {
          url += `&walletStatuses=${encodeURIComponent(walletStatuses)}`;
        }
        if (subscriptionStatuses) {
          url += `&subscriptionStatuses=${encodeURIComponent(subscriptionStatuses)}`;
        }
        if (userTypes) {
          url += `&userTypes=${encodeURIComponent(userTypes)}`;
        }
        if (sortBy) {
          url += `&sortBy=${encodeURIComponent(sortBy)}`;
        }
        if (sortOrder) {
          url += `&sortOrder=${encodeURIComponent(sortOrder)}`;
        }
        return request2({
          url: url,
          method: 'GET',
          headers: {
            "token": localStorage.getItem('adminToken') || localStorage.getItem('token'),
            "username": localStorage.getItem('username'),
          }
        })
      }
// 修改用户密码

export const editPassword = (username, newPassword) => {
    return request2({
      url: '/back/user/passwordReset',
      method: 'POST',
      data: { username: username, newPassword: newPassword },
      headers: {
        "token": localStorage.getItem('adminToken') || localStorage.getItem('token'),
        "username": localStorage.getItem('username'),
      }
    })
  }

  // 修改用户权限

export const editAuthority = (username, newAuthority) => {
  return request2({
    url: '/back/user/authority?username='+username+'&authorityId='+newAuthority,
    method: 'POST',
    headers: {
      "token": localStorage.getItem('adminToken') || localStorage.getItem('token'),
      "username": localStorage.getItem('username'),
    }
  })
}

/** 授予渲染管理员（RENDER.manageRender），仅 /admin/user 使用 */
export const grantRenderAdmin = (username) => {
  return request2({
    url: '/back/user/render-admin?username=' + encodeURIComponent(username),
    method: 'POST',
    headers: {
      token: localStorage.getItem('adminToken') || localStorage.getItem('token'),
      username: localStorage.getItem('username'),
    },
  })
}

/** 撤销渲染管理员（RENDER.manageRender） */
export const revokeRenderAdmin = (username) => {
  return request2({
    url: '/back/user/render-admin?username=' + encodeURIComponent(username),
    method: 'DELETE',
    headers: {
      token: localStorage.getItem('adminToken') || localStorage.getItem('token'),
      username: localStorage.getItem('username'),
    },
  })
}

  // 修改用户公司和地址
export const updateUserInfo = (username, nickname, source) => {
  let url = '/back/user/updateUserInfo?username=' + encodeURIComponent(username);
  // 只有当值不为 null 和 undefined 时才添加参数（空字符串也要传递，用于清空字段）
  if (nickname !== null && nickname !== undefined) {
    url += '&nickname=' + encodeURIComponent(nickname);
  }
  if (source !== null && source !== undefined) {
    url += '&source=' + encodeURIComponent(source);
  }
  return request2({
    url: url,
    method: 'POST',
    headers: {
      "token": localStorage.getItem('adminToken') || localStorage.getItem('token'),
      "username": localStorage.getItem('username'),
    }
  })
}

    // 新增训练项目
    export const createTrainingData = (data) => {
      return request2({
        url: '/back/training_data/create',
        method: 'POST',
        data,
        headers: {
          "token": localStorage.getItem('adminToken') || localStorage.getItem('token'),
          "username": localStorage.getItem('username'),
        }
      })
    }

       // 训练项目添加文件
       export const uploadTrainingData = (data) => {
        return request2({
          url: '/back/training_data/upload_file',
          method: 'POST',
          data,
          headers: {
            "token": localStorage.getItem('adminToken') || localStorage.getItem('token'),
            "username": localStorage.getItem('username'),
          }
        })
      }
    // 分页查询所有训练项目
    export const searchTrainingData = (pageNum, pageSize, project_name, structuralSystem) => {
      return request2({
        url: '/back/training_data/find_all?project_name='+project_name+'&page_num='+pageNum+'&page_size='+pageSize+'&structural_system='+structuralSystem,
        method: 'GET',
        headers: {
          "token": localStorage.getItem('adminToken') || localStorage.getItem('token'),
          "username": localStorage.getItem('username'),
        }
      })
    }
   // 删除某训练项目
   export const deleteTrainingData = (data) => {
    return request2({
      url: '/back/training_data/delete',
      method: 'POST',
      data,
      headers: {
        "token": localStorage.getItem('adminToken') || localStorage.getItem('token'),
        "username": localStorage.getItem('username'),
      }
    })
  }
  // 删除训练项目的某文件
  export const deleteTrainingFile = (data) => {
    return request2({
      url: '/back/training_data/delete_file',
      method: 'POST',
      data,
      headers: {
        "token": localStorage.getItem('adminToken') || localStorage.getItem('token'),
        "username": localStorage.getItem('username'),
      }
    })
  }

    // 更新训练项目信息
    export const updateTrainingData= (data) => {
      return request2({
        url: '/back/training_data/update',
        method: 'POST',
        data,
        headers: {
          "token": localStorage.getItem('adminToken') || localStorage.getItem('token'),
          "username": localStorage.getItem('username'),
        }
      })
    }

    // 更新训练项目的某文件
  export const updateTrainingFile = (data) => {
    return request2({
      url: '/back/training_data/update_file',
      method: 'POST',
      data,
      headers: {
        "token": localStorage.getItem('adminToken') || localStorage.getItem('token'),
        "username": localStorage.getItem('username'),
      }
    })
  }

  // 管理员删除用户
  export const deleteUser = (username) => {
    const formData = new FormData()
    formData.append('username', username)
    return request2({
      url: '/back/user/deleteUser',
      method: 'POST',
      data: formData,
      headers: {
        "token": localStorage.getItem('adminToken') || localStorage.getItem('token'),
        "username": localStorage.getItem('username'),
      }
    })
  }

  // 管理员封禁用户钱包
  export const setWalletAbandon = (username) => {
    const formData = new FormData()
    formData.append('username', username)
    return request2({
      url: '/back/user/setWalletAbandon',
      method: 'POST',
      data: formData,
      headers: {
        "token": localStorage.getItem('adminToken') || localStorage.getItem('token'),
        "username": localStorage.getItem('username'),
      }
    })
  }

  // 管理员解封用户钱包
  export const setWalletActive = (username) => {
    const formData = new FormData()
    formData.append('username', username)
    return request2({
      url: '/back/user/setWalletActive',
      method: 'POST',
      data: formData,
      headers: {
        "token": localStorage.getItem('adminToken') || localStorage.getItem('token'),
        "username": localStorage.getItem('username'),
      }
    })
  }

  // 管理员修改用户 AI 设计次数上限
  export const updateUserQuotaLimits = (userId, imageGenLimit, videoGenLimit, upscaleLimit) => {
    const formData = new FormData()
    formData.append('userId', userId)
    formData.append('imageGenLimit', imageGenLimit)
    formData.append('videoGenLimit', videoGenLimit)
    formData.append('upscaleLimit', upscaleLimit)
    return request2({
      url: '/back/user/updateUserQuotaLimits',
      method: 'POST',
      data: formData,
      headers: {
        "token": localStorage.getItem('adminToken') || localStorage.getItem('token'),
        "username": localStorage.getItem('username'),
      }
    })
  }

  // 管理员增减用户点数
  export const adjustUserPoints = (userId, pointType, points) => {
    const formData = new FormData()
    formData.append('userId', userId)
    formData.append('pointType', pointType)
    formData.append('points', points)
    return request2({
      url: '/back/user/adjustUserPoints',
      method: 'POST',
      data: formData,
      headers: {
        "token": localStorage.getItem('adminToken') || localStorage.getItem('token'),
        "username": localStorage.getItem('username'),
      }
    })
  }
